export const BROADCAST_CHANNEL_NAME = 'konto-frontend'

export enum BroadcastMessageType {
  SESSION_PROMPT_SHOW = 'session-prompt-show',
  SESSION_PROMPT_DISMISS = 'session-prompt-dismiss',
  SESSION_TIMEOUT = 'session-timeout',
  LOGIN = 'login',
  LOGOUT = 'logout',
}

export function registerBroadcastChannel(): BroadcastChannel {
  return new BroadcastChannel(BROADCAST_CHANNEL_NAME);
}

export function handleBroadcastMessage(event: MessageEvent, messageType: BroadcastMessageType, callback: () => void) {
  if (event.data.type !== BROADCAST_CHANNEL_NAME){
    return;
  }

  if (event.data.data === messageType) {
    callback();
  }
}
